<template>
    <main class="PrivacyNote-MAIN">

        <h1>
            Aviso de privacidad
        </h1>

        <div>
            <div class="hide-scrollbar" @scroll="measureScroll">

                AP(ART) respeta tu privacidad. Este Aviso de Privacidad describe qué
                información podemos recopilar cuando visitas nuestro sitio, para qué la
                usamos y qué opciones tienes sobre su uso.
                
                <br/><h2>1) Qué datos recopilamos</h2>
                Según tu interacción con el sitio, podemos recopilar:
                <ul>
                    <li>
                        <b>Datos de navegación y uso (anónimos o agregados):</b>
                        por ejemplo, páginas
                        visitadas, duración de la visita, rutas de navegación y eventos técnicos.
                        Estos datos se usan únicamente para entender el funcionamiento del sitio y
                        optimizar su arquitectura y experiencia. No buscamos identificarte
                        personalmente con esta información.
                    </li>
                    <li>
                        <b>Datos que tú nos proporcionas de forma voluntaria:</b>
                        por ejemplo, si nos
                        escribes mediante un formulario o nos contactas para solicitar información,
                        un dossier o para iniciar una conversación privada relacionada con obra,
                        disponibilidad o colaboración (típicamente: nombre, correo, mensaje y
                        datos que decidas incluir).
                    </li>
                </ul>
                
                <br/><h2>2) Cookies y tecnologías similares</h2>
                Nuestro sitio puede utilizar:
                <ul>
                    <li>
                        <b>Cookies estrictamente necesarias:</b>
                        son esenciales para el funcionamiento,
                        la seguridad y la navegación. Siempre están activas.
                    </li>
                    <li>
                        <b>Cookies o herramientas de análisis (opcionales):</b>
                        nos permiten medir de
                        forma anónima patrones de navegación para mejorar el sitio. Puedes
                        aceptarlas o rechazarlas desde la ventana de cookies.
                    </li>
                        <li>
                        <b>Sin marketing ni rastreo publicitario:</b>
                        AP(ART) no utiliza cookies
                        publicitarias, píxeles de seguimiento ni rastreadores orientados a
                        publicidad, y no buscamos monetizar tus datos mediante publicidad
                        personalizada.
                    </li>
                </ul>
                
                <br/><h2>3) Finalidades del tratamiento</h2>
                Usamos la información para:
                <ul>
                    <li>
                        <b>Operación y seguridad del sitio</b> (funcionamiento esencial).
                    </li>
                    <li>
                        <b>Mejora y mantenimiento</b> de la experiencia y la estructura del sitio mediante análisis anónimo.
                    </li>
                    <li>
                        <b>Atender solicitudes</b> de contacto, información, adquisición de obra o colaboración institucional.
                    </li>
                </ul>
                
                <br/><h2>4) Base legal y consentimiento (cuando aplique)</h2>
                <ul>
                    <li>
                        Para cookies esenciales, el tratamiento se realiza por necesidad técnica para prestar el servicio del sitio.
                    </li>
                    <li>
                        Para herramientas de análisis no esenciales, usaremos tu información <b>solo si otorgas consentimiento</b> en la ventana de cookies.
                    </li>
                </ul>
                
                <br/><h2>5) Transferencias a terceros</h2>
                No compartimos tus datos con terceros para fines publicitarios. En caso de
                usar proveedores técnicos (por ejemplo, hosting, analítica o formularios), se
                limitarán a operar el servicio y a proteger la información conforme a este aviso.
                
                <br/><h2>6) Conservación</h2>
                Conservaremos los datos solo durante el tiempo necesario para cumplir las
                finalidades descritas (por ejemplo, resolver una solicitud de contacto) o para
                obligaciones aplicables. Los datos de analítica se manejan en forma
                agregada/anónima para mejora continua.
                
                <br/><h2>7) Tus opciones y controles</h2>
                <ul>
                    <li>
                        Puedes <b>aceptar o rechazar</b> las cookies de análisis desde el banner.
                    </li>
                    <li>
                        Puedes cambiar tu decisión en cualquier momento (por ejemplo, borrando
                        cookies en tu navegador y volviendo a configurar preferencias cuando se
                        muestre de nuevo el banner).
                    </li>
                </ul>
                
                <br/><h2>8) Derechos sobre tus datos</h2>
                Puedes solicitar acceso, rectificación, cancelación u oposición, así como
                revocar consentimiento cuando aplique, escribiéndonos al correo de contacto
                indicado abajo (o el que definas como oficial).
                
                <br/><h2>9) Contacto</h2>
                <b>Responsable:</b>
                <br/><b>Correo:</b>
                <br/><b>Asunto sugerido:</b> “Privacidad AP(ART)”

            </div>
        </div>

        <button @click="goToContact()">CONTACTO</button>

    </main>
</template>

<script>
export default {
    name: 'SectionPrivacyNote',
    inject: ['vibrationScrollEnd'],
    data(){
        return{

        }
    },
    methods: {

        measureScroll(e){
            this.vibrationScrollEnd(e);
        },

        goToContact(){
            this.$router.push({ name: 'contact', params: { id: String(this.id) || null }, query: { from: 'about' } });
        }

    }
}
</script>

<style scoped lang="stylus">
.PrivacyNote-MAIN
    height: 100vh
    max-height: 100vh
    display: flex
    flex-direction: column
    align-items: center
    background-color: white

    .PrivacyNote-arr-back
        max-width: 6vw
        max-height: 6vw
        position: fixed
        top: 4vw
        left: 4vw
        z-index 1

    >*
        max-width: calc(100% - 8vw)

    h1
        margin-top: 10vw
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 20vw
        margin-top: 1.5ch
        margin-bottom: 0

    >div
        position: relative

        &::after
        &::before
            content: ""
            position: absolute
            width: 100%
            height: 5ch
        
        &::after
            top: 0
            background: linear-gradient(white, transparent)

        &::before
            bottom: 0
            background: linear-gradient(transparent, white)

        >div
            border-radius: 1ch
            font-family: "Archivo ExtraCondensed", sans-serif
            padding: 4ch 0
            max-height: calc(100vh - 30vw - ((47px + 6vw + 6vw) * 2) - 8ch)
            overflow: auto
            color: #707070
            font-size: 5vw

            blockquote
                background-color: lightgray
                border-left: 1ch solid #bbb
                padding: 1ch 0
                padding-left: 1ch
                margin: 0
                border-radius: 3px

    >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: #015aff
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace
        border: none
</style>